import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NavigationActionButton.module.css';

const NavigationActionButton = ({
    isRoutingMode,
    isDrivingMode,
    hasRoute,
    onToggleRouting,
    onToggleDriving
}) => {
    const { t } = useTranslation();
    const handleClick = (e) => {
        e.preventDefault();
        if (isDrivingMode) {
            onToggleDriving(); // Stop Driving -> Browse
            onToggleRouting(); // Also exit routing mode
        } else if (isRoutingMode) {
            if (hasRoute) {
                onToggleDriving(); // Start Driving
            } else {
                onToggleRouting(); // Cancel -> Browse
            }
        } else {
            onToggleRouting(); // Browse -> Navigate
        }
    };

    const getButtonConfig = () => {
        if (isDrivingMode) {
            return {
                title: t('navigation.cancel'), // Using cancel for now as it stops it.
                icon: "fa-times",
                className: styles.CancelMode
            };
        }
        if (isRoutingMode) {
            if (hasRoute) {
                return {
                    title: t('navigation.drive'),
                    icon: "fa-car",
                    className: styles.DriveMode
                };
            }
            return {
                title: t('navigation.cancel'),
                icon: "fa-times",
                className: styles.CancelMode
            };
        }
        return {
            title: t('navigation.navigate'),
            icon: "fa-location-arrow",
            className: styles.NavigateMode
        };
    };

    const config = getButtonConfig();

    return (
        <button
            className={`${styles.NavigationActionButton} ${config.className}`}
            title={config.title}
            aria-label={config.title}
            onClick={handleClick}
        >
            <i className={`fa ${config.icon}`}></i>
            <span>{config.title}</span>
        </button>
    );
};

export default NavigationActionButton;
